import update from "immutability-helper";

export const NAME = "studentGoals";

export const UPDATE_GOAL_COUNT = "UPDATE_GOAL_COUNT " + NAME;
export const UPDATE_SELECTED_TAB = "UPDATE_SELECTED_TAB " + NAME;
export const UPDATE_SELECTED_ITEM_ID = "UPDATE_SELECTED_ITEM_ID " + NAME;
export const UPDATE_GOAL_EDITOR_MODE = "UPDATE_GOAL_EDITOR_MODE " + NAME;
export const UPDATE_STUDENT_ID = "UPDATE_STUDENT_ID " + NAME;
export const UPDATE_STUDENT_INFO = "UPDATE_STUDENT_INFO " + NAME;
export const UPDATE_SEARCH_TEXT = "UPDATE_SEARCH_TEXT " + NAME;
export const UPDATE_GRADES = "UPDATE_GRADES " + NAME;
export const UPDATE_SELECTED_STUDENTS = "UPDATE_SELECTED_STUDENTS " + NAME;
export const UPDATE_GOAL_TO_DUPLICATE = "UPDATE_GOAL_TO_DUPLICATE " + NAME;
export const UPDATE_PARENT_PAGE_INFO = "UPDATE_PARENT_PAGE_INFO " + NAME;
export const UPDATE_COURSE_FILTERS = "UPDATE_COURSE_FILTERS " + NAME;
export const UPDATE_SELECT_ALL_FOR_DUPLICATION =
  "UPDATE_SELECT_ALL_FOR_DUPLICATION " + NAME;
export const UPDATE_IS_NOTIFICATION_PROCESSED =
  "IS_NOTIFICATION_PROCESSED " + NAME;

export const updateGoalCount = payload => ({
  type: UPDATE_GOAL_COUNT,
  payload,
});

export const updateSelectedTab = payload => ({
  type: UPDATE_SELECTED_TAB,
  payload,
});

export const updateSelectedItemId = payload => ({
  type: UPDATE_SELECTED_ITEM_ID,
  payload,
});

export const updateGoalEditorMode = payload => ({
  type: UPDATE_GOAL_EDITOR_MODE,
  payload,
});

export const updateStudentId = payload => ({
  type: UPDATE_STUDENT_ID,
  payload,
});

export const updateStudentInfo = payload => ({
  type: UPDATE_STUDENT_INFO,
  payload,
});

export const updateSearchText = payload => ({
  type: UPDATE_SEARCH_TEXT,
  payload,
});

export const updateSelectedStudents = payload => ({
  type: UPDATE_SELECTED_STUDENTS,
  payload,
});

export const updateGoalToDuplicate = payload => ({
  type: UPDATE_GOAL_TO_DUPLICATE,
  payload,
});

export const updateParentPageInfo = payload => ({
  type: UPDATE_PARENT_PAGE_INFO,
  payload,
});

export const updateCourseFilters = payload => ({
  type: UPDATE_COURSE_FILTERS,
  payload,
});

export const updateSelectAllForDuplication = payload => ({
  type: UPDATE_SELECT_ALL_FOR_DUPLICATION,
  payload,
});

export const updateIsNotificationProcessed = payload => ({
  type: UPDATE_IS_NOTIFICATION_PROCESSED,
  payload,
});

const REDUCER_HANDLERS = {
  [UPDATE_GOAL_COUNT]: (state, action) => {
    const params = action.payload;
    return update(state, {
      studentGoalsCount: { $set: params },
    });
  },
  [UPDATE_SELECTED_TAB]: (state, action) => {
    const params = action.payload;
    return update(state, {
      selectedTab: { $set: params },
    });
  },
  [UPDATE_SELECTED_ITEM_ID]: (state, action) => {
    const params = action.payload;
    return update(state, {
      selectedItemId: { $set: params },
    });
  },
  [UPDATE_GOAL_EDITOR_MODE]: (state, action) => {
    const params = action.payload;
    return update(state, {
      goalEditorMode: { $set: params },
    });
  },
  [UPDATE_STUDENT_ID]: (state, action) => {
    const params = action.payload;
    return update(state, {
      studentId: { $set: params },
    });
  },
  [UPDATE_STUDENT_INFO]: (state, action) => {
    const params = action.payload;
    return update(state, {
      studentInfo: { $set: params },
    });
  },
  [UPDATE_SEARCH_TEXT]: (state, action) => {
    const params = action.payload;
    return update(state, {
      searchText: { $set: params },
    });
  },
  [UPDATE_GRADES]: (state, action) => {
    const params = action.payload;
    return update(state, {
      grades: { $set: params },
    });
  },
  [UPDATE_SELECTED_STUDENTS]: (state, action) => {
    const params = action.payload;
    return update(state, {
      selectedStudents: { $set: params },
    });
  },
  [UPDATE_SELECTED_STUDENTS]: (state, action) => {
    const params = action.payload;
    return update(state, {
      selectedStudents: { $set: params },
    });
  },
  [UPDATE_GOAL_TO_DUPLICATE]: (state, action) => {
    const params = action.payload;
    return update(state, {
      goalToDuplicate: { $set: params },
    });
  },
  [UPDATE_PARENT_PAGE_INFO]: (state, action) => {
    const params = action.payload;
    return update(state, {
      parentPageInfo: { $set: params },
    });
  },
  [UPDATE_COURSE_FILTERS]: (state, action) => {
    const params = action.payload;
    return update(state, {
      courseFilters: { $set: params },
    });
  },
  [UPDATE_SELECT_ALL_FOR_DUPLICATION]: (state, action) => {
    const params = action.payload;
    return update(state, {
      selectAllForDuplication: { $set: params },
    });
  },
  [UPDATE_IS_NOTIFICATION_PROCESSED]: (state, action) => {
    const params = action.payload;
    return update(state, {
      isNotificationProcessed: { $set: params },
    });
  },
};

const initialState = {
  studentGoalsCount: {
    completed: 0,
    ongoing: 0,
  },
  selectedTab: "ONGOING",
  selectedItemId: "",
  goalEditorMode: "add",
  studentId: "",
  studentInfo: {},
  searchText: "",
  grades: [],
  selectedStudents: [],
  goalToDuplicate: {},
  parentPageInfo: {},
  courseFilters: {
    courses: [],
    searchText: "",
  },
  selectAllForDuplication: {
    isChecked: false,
    removedItems: [],
    totalCount: 0,
  },
  isNotificationProcessed: false,
};

export default function myReducer(state = initialState, action) {
  const handler = REDUCER_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
}
